<script>
import ModuleTitle from '../common/ModuleTitle.vue'
import Module9Item from '../content/Module9Item.vue'
import Module30Item from '../content/Module30Item.vue'
import Module63Item from '../content/Module63Item.vue'

import { mapGetters } from 'vuex'
import { getSubPage } from '@/api/pageData'

export default {
  name: 'DialogId12',
  components: { ModuleTitle, Module9Item, Module30Item, Module63Item },
  props: {
    currentModule: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      path: this.$route.path,
      pageData: [],
      currentPageData: {},
      previewShow: false
    }
  },
  computed: {
    ...mapGetters({
      currentModuleIdGetter: 'config/getCurrentModuleId'
    }),
    currentModuleId() {
      return this.currentModuleIdGetter
    }
  },
  created() {
    this.initPageData()
  },
  methods: {
    onFileClick(v) {
      this.currentPageData = v
      this.previewShow = true
    },

    initPageData() {
      const params = {
        title: this.currentModule.title,
        titleid: Number(this.currentModule.titleid),
        subtitle: this.currentModule.subtitle || '',
        userid: localStorage.getItem('screenUserid') || 0,
        village: localStorage.getItem('currentCommunity') || ''
      }
      getSubPage(params).then(res => {
        if (res.code === 0) this.pageData = res.msg[0].list
      })
    }
  }
}
</script>

<template>
  <div class="dialog-id-12">
    <div class="title-container">
      <module-title :title="currentModule.title" margin-bottom="40" />
    </div>
    <div v-if="currentModuleId == 9 || currentModuleId == 51" class="group-container">
      <module9-item
        v-for="(v, i) in pageData"
        :key="`dialog10-id-${i}`"
        :headline="v.memo"
        :name="v.name"
        size="large"
      />
    </div>
    <div v-if="currentModuleId == 30" class="group-container2">
      <p class="subtitle">{{ currentModule.subtitle }}</p>
      <div class="item-container">
        <module30-item
          v-for="(v, i) in pageData"
          :key="`dialog30-id-${i}`"
          :name="v.name"
          :memo="v.memo"
          size="large"
        />
      </div>
    </div>
    <div v-if="currentModuleId == 63" class="group-container">
      <module63-item
        v-for="(v, i) in pageData"
        :key="`dialog63-id-${i}`"
        :name="v.name"
        :memo="v.memo"
        size="large"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
// 1330
.dialog-id-12 {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.title-container {
  width: 100%;
}

.group-container2 {
  width: 900px;
  display: flex;
  align-content: flex-start;
  height: 610px;
  overflow-y: scroll;
  &::-webkit-scrollbar { // chrome/safari
    display: none;
  }
  scrollbar-width: none; // firefox
  -ms-overflow-style: none; // IE10+
}
.item-container {
  display: flex;
  column-gap: 30px;
  row-gap: 30px;
  flex-wrap: wrap;
  margin-left: 40px;
}

.subtitle {
  width: 48px;
  height: 180px;
  writing-mode: vertical-rl;
  font-size: 16px;
  font-family: siyuansong;
  font-weight: 800;
  color: #CC0A66;
  letter-spacing: 2px;
  background: url('~imgs/modules/id-30-subtitle.png') no-repeat center;
  background-size: 100% 100%;
  display: grid;
  place-items: center;
}
.group-container {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  width: 1080px;
  padding: 10px;
  column-gap: 40px;
  row-gap: 30px;
  height: 610px;
  overflow-y: scroll;
  &::-webkit-scrollbar { // chrome/safari
    display: none;
  }
  scrollbar-width: none; // firefox
  -ms-overflow-style: none; // IE10+
}
</style>
